module.exports = __webpack_public_path__ + "7cb90afdc2e476f2c9c368069b4653cf.png";